import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

import { useTranslation } from 'react-i18next';
import { AllCategoryTableProps, CategoryData } from '../types';
import styles from './styles.module.css';

export const AllCategoryTable = ({ data }: AllCategoryTableProps) => {
  const { t } = useTranslation(); 
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, payload, index }: any) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.4;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    const total = payload.payload._total || 1;
    const percent = ((value / total) * 100).toFixed(0);

    return (
      <text
        x={x}
        y={y}
        fill={payload.color}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{ fontSize: '14px', fontWeight: 500 }}
      >
        {`${percent}%`}
      </text>
    );
  };

  const renderPieChart = (year: string) => {
    const yearData = data?.[year];
    if (!yearData || yearData.length === 0) return null;

    const total = yearData.reduce((sum, item) => sum + item.value, 0);
    if (total === 0) return null;

    const dataWithTotal = yearData.map(item => ({
      ...item,
      _total: total
    }));

    return (
      <div className={styles.chartWrapper} key={year}>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={dataWithTotal}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={90}
              paddingAngle={2}
              dataKey="value"
              startAngle={90}
              endAngle={450}
              label={renderCustomLabel}
              labelLine={false}
            >
              {dataWithTotal.map((entry, index) => (
                <Cell key={index} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.yearLabel}>{year} г.</div>
        <div className={styles.legendTable}>
          {yearData.map((item, index) => (
            <div key={index} className={styles.legendItem}>
              <span className={styles.legendDot} style={{ backgroundColor: item.color }}></span>
              <span className={styles.legendText}>
                {item.name} - {item.value} {t('employees')}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (!data || Object.keys(data).length === 0) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>{t('Structure of employees by categories')}</h2>
        <div className={styles.noData}>Нет данных для отображения</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('Structure of employees by categories')}</h2>
      <div className={styles.chartsContainer}>
        {Object.keys(data).map(year => renderPieChart(year))}
      </div>
    </div>
  );
};
